import React from "react"
import { Box } from "@mui/material"
import { AppFormGrid, AppMoreOptions } from "@components"
import {
	CheckinWeekdayField,
	DaysToMonitorField,
	PickupDatesSubSection,
	RentalLengthField,
	TerminationDateField,
	TimeFromSelector,
	TimeToSelector
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useSignal } from "@preact/signals-react"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"

export default function ReportFormDrawerDateSection() {


	return <AppFormGrid>
		<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-pickup-dates">
			<PickupDatesSubSection/>
		</Box>
		<Box sx={{ gridColumn: 'span 4' }} data-tour-id="tour-rental-length">
			<RentalLengthField/>
		</Box>
		<Box sx={{ gridColumn: 'span 4' }} data-tour-id="tour-days-monitor">
			<DaysToMonitorField/>
		</Box>
		<Box sx={{ gridColumn: 'span 2' }} data-tour-id="tour-pickup-time">
			<TimeFromSelector/>
		</Box>
		<Box sx={{ gridColumn: 'span 2' }} data-tour-id="tour-dropoff-time">
			<TimeToSelector/>
		</Box>
		<MoreFeaturesSection/>
	</AppFormGrid>
}

function MoreFeaturesSection() {

	const showFeatures = useSignal(!!reportFormData.peek().checkinWeekdayFilter?.length || !!reportFormData.peek().terminationDate?.length)


	return <AppMoreOptions open={showFeatures.value} onToggle={() => showFeatures.value = !showFeatures.value}>
		<AppFormGrid>
			<Box sx={{ gridColumn: 'span 6' }}>
				<CheckinWeekdayField/>
			</Box>
			<Box sx={{ gridColumn: 'span 4' }}>
				<TerminationDateField/>
			</Box>
		</AppFormGrid>
	</AppMoreOptions>
}
